import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthenticationService, SessionTabSyncService } from '../_services';
import { persistGotoForLogin } from 'app/_utils/helpers';

/** Sign-in and password-reset calls must not carry a leftover JWT. */
function isPublicAuthRequest(url: string): boolean {
  const u = url.toLowerCase();
  return u.includes('/auth/signin')
    || u.includes('/auth/signup')
    || u.includes('/auth/forgot_password')
    || u.includes('/auth/forgot_username')
    || u.includes('/auth/reset_password')
    || u.includes('/auth/test_username')
    || u.includes('/auth/callback_apple');
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private inj: Injector,
    private router: Router,
    private sessionTabSync: SessionTabSyncService,
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authenticationService = this.inj.get(AuthenticationService);
    const token = authenticationService.token();
    const skipAuthHeader = req.url.toLowerCase().includes('amazonaws.com')
      || isPublicAuthRequest(req.url);
    if (token && !req.headers.get('Authorization') && !skipAuthHeader) {
      const authReq = req.clone({ headers: req.headers.set('Authorization', token) });
      const requestToken = token;
      return next
        .handle(authReq)
        .pipe(
          tap(event => { }, err => {
            if (err.status === 401) {
              const currentToken = authenticationService.token();
              if (!currentToken || requestToken !== currentToken) {
                return;
              }
              const returnUrl = this.router.url;
              if (returnUrl === '/login' || returnUrl.startsWith('/login?') || returnUrl.startsWith('/login;')) {
                authenticationService.logout(true);
                return;
              }
              this.sessionTabSync.dismissModalsLocally();
              authenticationService.logout(true);
              this.router.navigate(['login'], { queryParams: persistGotoForLogin(returnUrl) });
            }
          })
        );
    } else {
      return next.handle(req);
    }
  }
}
